(function () {
  'use strict';

  /* ---------- Show more / progressive reveal ---------- */
  document.querySelectorAll('[data-reviews-grid]').forEach(function (grid) {
    var increment = parseInt(grid.getAttribute('data-increment'), 10) || 8;
    var section = grid.closest('.reviews-section');
    var button = section ? section.querySelector('[data-reviews-show-more]') : null;
    if (!button) return;

    button.addEventListener('click', function () {
      var hidden = grid.querySelectorAll('.review-card.is-hidden');
      if (!hidden.length) return;

      for (var i = 0; i < hidden.length && i < increment; i++) {
        hidden[i].classList.remove('is-hidden');
      }

      var stillHidden = grid.querySelectorAll('.review-card.is-hidden');
      if (!stillHidden.length) {
        button.setAttribute('hidden', 'hidden');
        button.setAttribute('aria-expanded', 'true');
      }
    });
  });

  /* ---------- Write a review modal ---------- */
  var overlay = document.querySelector('[data-reviews-modal-overlay]');
  if (overlay) {
    var openButtons = document.querySelectorAll('[data-reviews-open-modal]');
    var closeButton = overlay.querySelector('[data-reviews-close-modal]');
    var modal = overlay.querySelector('.reviews-modal');

    function openModal() {
      overlay.removeAttribute('hidden');
      document.body.style.overflow = 'hidden';
      var firstField = overlay.querySelector('input, textarea');
      if (firstField) firstField.focus();
    }

    function closeModal() {
      overlay.setAttribute('hidden', 'hidden');
      document.body.style.overflow = '';
    }

    openButtons.forEach(function (btn) {
      btn.addEventListener('click', openModal);
    });

    if (closeButton) closeButton.addEventListener('click', closeModal);

    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) closeModal();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !overlay.hasAttribute('hidden')) closeModal();
    });

    // Auto-open modal after a successful submission so the thank-you
    // message (rendered server-side via form.posted_successfully?) is visible.
    if (overlay.querySelector('.reviews-modal-success')) {
      openModal();
    }
  }

  /* ---------- Review form: fold rating + optional photo link into the message body ---------- */
  var reviewForm = document.getElementById('ReviewForm');
  if (reviewForm) {
    reviewForm.addEventListener('submit', function () {
      var ratingInput = reviewForm.querySelector('input[name="rating"]:checked');
      var ratingValue = ratingInput ? ratingInput.value : 'Not selected';
      var photoField = document.getElementById('review-photo-link');
      var photoValue = photoField && photoField.value ? photoField.value.trim() : '';
      var bodyField = reviewForm.querySelector('textarea[name="contact[body]"]');

      if (bodyField) {
        var prefix = 'Rating: ' + ratingValue + '/5\n';
        if (photoValue) prefix += 'Photo link: ' + photoValue + '\n';
        prefix += '\nReview:\n';
        bodyField.value = prefix + bodyField.value;
      }
    });
  }
})();
